// extracted by mini-css-extract-plugin
export default {"tabs":"MFsRsEQPcV","full-width":"ApRLhwaC67","fullWidth":"ApRLhwaC67"};